// extracted by mini-css-extract-plugin
export default {"boilerPlate":"BoilerPlate_boilerPlate__zrosw","mainContent":"BoilerPlate_mainContent__1oWtX"};